import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-nested-tab',
  templateUrl: './nested-tab.component.html',
})

export class NestedTabComponent {

  constructor(private router: Router,
    private route: ActivatedRoute) {}

}
